import { useTranslation } from 'react-i18next';

import Header from '../../../styledComponents/PageDetails/HeaderPageDetails/HeaderPageDetails';
import FormErrorProvider from '../../../styledComponents/FormErrorProvider/FormErrorProvider';
import AddContractModal from '../../../styledComponents/Modals/AddContractModal/AddContractModal';
import Spinner from '../../../styledComponents/Spinner/Spinner';

import { ProductType } from '../../../models/ProductType';
import { useDOCEditSubscriptionRenewPage } from './docEditSubscriptionRenewPage.hooks';
import DOCEditSubscriptionRenewPageForm from './DOCSubscriptionRenewPageForm/DOCSubscriptionRenewPageForm';
import DOCEditSubscriptionAnalyseModal from './DOCEditSubscriptionAnalyseModal/DOCEditSubscriptionAnalyseModal';

export const DOCSubscriptionRenewPage = () => {
  const { t } = useTranslation();
  const {
    organization,
    dataLoading,
    loadDatesForNewSubscriptionHandler,
    loadSubscriptionRenewalSuggestionHandler,
  } = useDOCEditSubscriptionRenewPage();

  if (dataLoading) {
    return <Spinner />;
  }

  return (
    <>
      <AddContractModal />
      <DOCEditSubscriptionAnalyseModal
        onAnalyseSuccess={loadSubscriptionRenewalSuggestionHandler}
      />
      <FormErrorProvider>
        <>
          <Header
            title={t('headers.edit-renew-subscription', {
              productType: ProductType.DutyOfCare,
              organizationName: organization?.name,
            })}
          />
          <DOCEditSubscriptionRenewPageForm
            onContractChanged={loadDatesForNewSubscriptionHandler}
          />
        </>
      </FormErrorProvider>
    </>
  );
};
